export default {
  currentPopup: {
    state: null,
    name: null,
    // Храниться общая доп инфа для попапа(если надо), опционально
    value: null,
  },
  currentPopover: {
    state: null,
    name: null,
  },
  dangerPopup: {
    isOpen: false,
    text: ''
  },
  popupModelAbout: null,
  showLogo: true,
  showBasket: true,
  // по умолчанию всегда открыта первая вкладка
  sectionActive: "models",
  country: false,
  preload: false,
  route: null,
  // триггер для повторного запроса списка заказов, если есть изменения
  isUpdateOrders: false,
}
